import React, { FC } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

import { Title, Text, ButtonStyled } from '../CssStyled'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import { Trans, lng } from '@ads/front-core/locales'
import IconMAVisualization from './MAVisualization'

const MarketingAutomation: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('marketing-automation')}>
    <Container>
      <TitleStyled bold>{lng('landing:marketingAutomation')}</TitleStyled>
      <Content>
        <div>
          <Text>{lng('landing:marketingAutomationDescription')}</Text>
        </div>

        <div>
          <ListTitleWrapper>
            <Text>{lng('landing:marketingAutomationTitle')}</Text>
          </ListTitleWrapper>
          <List>
            <Text>
              <Trans
                i18nKey="landing:marketingAutomationElements"
                components={{ listElement: <li /> }}
              />
            </Text>
          </List>
        </div>
        <ButtonGetStarted to="/marketing-automation/">
          {lng('landing:findOutMore')}
        </ButtonGetStarted>
      </Content>
      <MAVisualizationWrapper>
        <IconMAVisualization />
      </MAVisualizationWrapper>
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
  padding: 60px 0px 84px;
  gap: 40px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    bottom: 0;
    top: 0;
    background-color: #f2f3f5;
    z-index: -1;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-template-columns: 1fr;
    gap: 0;
    padding-bottom: 56px;
  }
`

const TitleStyled = styled(Title)`
  grid-column: 1;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1;
  gap: 40px;
`

const MAVisualizationWrapper = styled.div`
  position: relative;
  grid-column: 2;
  grid-row: 1/ 3;
  align-self: center;
  justify-self: center;

  svg {
    height: 500px;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-column: 1;
    grid-row: 2;
    justify-self: center;
    margin: 42px 0;

    svg {
      width: 300px;
      height: 324px;
    }
  }
`

const ListTitleWrapper = styled.div`
  margin-bottom: 24px;
`

const List = styled.ul`
  margin: 0;
`

const ButtonGetStarted = styled(Link)`
  ${ButtonStyled}

  @media (max-width: ${breakpoints.MOBILE}) {
    align-self: center;
  }
`

export default MarketingAutomation
